<svelte:options customElement="auth-svelte" />

<script>
  import firebase from 'firebase/compat/app'
  import 'firebase/compat/auth'
  import { token } from './store'
  
  const auth = firebase.auth()

  let user = null

  const userMapper = (claims) => ({
    id: claims.user_id,
    name: claims.name,
    email: claims.email,
    picture: claims.picture,
  })

  export const loginWithEmailPassword = (email, password) =>
    auth.signInWithEmailAndPassword(email, password)

  export const logout = () => {
    token.set('')
    return auth.signOut()
  }

  auth.onAuthStateChanged(async (fireUser) => {
    if (fireUser) {
      const userToken = await fireUser.getIdTokenResult()
      user = userMapper(userToken.claims)
      token.set(`Bearer ${userToken.token}`)
    } else {
      user = null
      token.set('')
    }
  })

  auth.onIdTokenChanged(async function (fireUser) {
    if (fireUser) {
      const userToken = await fireUser.getIdTokenResult()
      user = userMapper(userToken.claims)
      token.set(`Bearer ${userToken.token}`)
    } else {
      user = null
      token.set('')
    }
  })
  $: loggedIn = user !== null
</script>

<div>
  <slot {user} {loggedIn} {loginWithEmailPassword} {logout} />
</div>
